import { Box, Text, Flex, SimpleGrid } from '@chakra-ui/react'
import { Image } from '@/components/HOC/Image'
import { nftsImages } from '@/helpers/nftsImages'
import { useTranslation } from 'next-i18next/pages'

export const UserNfts = ({
  nfts,
}: {
  nfts: Array<{
    type: string
    amount: number
  }>
}) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Flex mb={5} justifyContent={'space-between'} alignItems={'center'}>
        <Text fontSize={'xl'} fontWeight={700}>
          {t('profile.nfts')}
        </Text>
        {/* <ChakraLink
          _hover={{
            textDecor: 'none',
          }}
          href={'https://injective.talis.art/collection/65d214819b0824cc8e79d0d9'}
          target="_blank"
        >
          <Text
            fontWeight={700}
            color={'brand.indygo'}
            bgBlendMode={'overlay'}
            bg={`linear-gradient(291.97deg, #8E83FB 31.11%, #5D52EE 97.01%), rgba(255, 255, 255, 0.2)`}
            backgroundClip={'text'}
            __css={{
              '-webkit-text-fill-color': 'transparent',
            }}
            _hover={{
              opacity: 0.8,
            }}
          >
            See Collection
          </Text>
        </ChakraLink> */}
      </Flex>

      <SimpleGrid
        h={{ base: 'auto', md: 'calc(100% - 50px)', xl: 'auto' }}
        columns={{ base: 3, md: 3 }}
        gap={3}
        p={6}
        alignContent={'start'}
        rounded={'2xl'}
        bg={'ninja.600'}
      >
        {nfts?.map((nft, index) => {
          return (
            <Box key={index} pos={'relative'}>
              <Flex
                fontSize={'xs'}
                w={6}
                h={6}
                fontWeight={700}
                pos={'absolute'}
                top={-2}
                right={-2}
                bg={'ninja.500'}
                color={'ninja.100'}
                rounded={'full'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                {nft.amount}
              </Flex>
              <Image src={nftsImages[nft.type as keyof typeof nftsImages]} alt={''} />
            </Box>
          )
        })}
      </SimpleGrid>
    </Box>
  )
}
